import ReportConstructorController from "./report-constructor-controller";
import { connect } from "react-redux";
import { compose } from "redux";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { getValue } from "../../store/languages";
import { getMe } from "store/account";
import { getMyTopics, setThemeTableData } from "store/theme-settings";
import { getTopicDropdownFromState, getTopics, getSubtopicsFromState, getTopicsFiltersSelectorTree } from "selectors/theme-selector";
import { setLeftMenuComponent, setRemoveLeftMenuComponent, setRightMenuComponent, setRemoveRightMenuComponent, setShowLeftMenu, setShowRightMenu } from 'store/side-bar';
import { setShowPanel } from "store/header";
import { setItemsCount, setCurrentPage, setShowedItemsCount } from "store/paginator";
import { getReportConstructorTemplates, setSelectedReportTemplate, updateReportConstructor, setIsReportUpdated, updateReportConstructorTemplateComponents, setIsReadOnly, setCreateStatus, deleteReportTemplate } from "store/report-constructor";
import { modalShowToggle } from "store/modal";
 
let mapStateToProps = (state) => {
    return {
        role: state.Account.role,
        deviceType: state.header.deviceType,
        reportTemplates: state.ReportConstructor.reportTemplates,
        controlButtons: state.ReportConstructor.controlButtons,
        topics: getTopicsFiltersSelectorTree(state),
        reportComponents: state.ReportConstructor.reportComponents,
        reportParameters: state.ReportConstructor.reportParameters,
        fonts: state.ReportConstructor.fonts,
        leftMenuComponent: state.SideBarMenu.leftMenuComponent,
        rightMenuComponent: state.SideBarMenu.rightMenuComponent,
        colors: state.ReportConstructor.colors,
        selectedReportTemplate: state.ReportConstructor.selectedReportTemplate,
        isReportsUpdated: state.ReportConstructor.isReportsUpdated,
        textRepresentationList: state.ReportConstructor.textRepresentationList,
        dateFields: state.ReportConstructor.dateFields,
        groupingTypeList: state.ReportConstructor.groupingTypeList,
        documentElementsList: state.ReportConstructor.documentElementsList,
        includeTocList: state.ReportConstructor.includeTocList,
        isReadOnly: state.ReportConstructor.isReadOnly,
        selectedLanguage: state.languages.selectedLanguage,
        createdStatus: state.ReportConstructor.createdStatus,
        totalElements: state.ReportConstructor.totalElements,
        currentPage: state.paginator.currentPage,
        itemsCount: state.paginator.itemsCount,
        showedItemsCount: state.paginator.showedItemsCount,
        feedSettings: state.ReportConstructor.feedSettings
    }
}

const ReportConstructorContainer = compose(connect(mapStateToProps, { 
                                                            getValue, 
                                                            getMe, 
                                                            getMyTopics, 
                                                            setLeftMenuComponent, 
                                                            setRemoveLeftMenuComponent, 
                                                            setRightMenuComponent, 
                                                            setRemoveRightMenuComponent, 
                                                            setShowLeftMenu, 
                                                            setShowRightMenu, 
                                                            setShowPanel, 
                                                            getReportConstructorTemplates, 
                                                            setSelectedReportTemplate, 
                                                            modalShowToggle,
                                                            updateReportConstructor,
                                                            setIsReportUpdated,
                                                            updateReportConstructorTemplateComponents,
                                                            setIsReadOnly,
                                                            setCreateStatus,
                                                            setItemsCount, 
                                                            setCurrentPage, 
                                                            setShowedItemsCount,
                                                            deleteReportTemplate
                                                        }),withAuthRedirect)(ReportConstructorController);

export default ReportConstructorContainer;

